export const SET_LIST = 'DICTIONARIES/SET_LIST';
export const SET_LOADER = 'DICTIONARIES/SET_LOADER';
